import { AxiosInstance } from "axios";
import API from "../../../utils/api";
import { PaginatedRequest } from "../../../models/core/paginated.request";
import { PaginatedResult } from "../../../models/core/paginated.result";
import { ArticlesPriceList } from "../../../models/articles/articles.price-lists";

export class ArticlesPriceListsService {
    api: AxiosInstance = API;

    getAll(
        request: PaginatedRequest
    ): Promise<PaginatedResult<ArticlesPriceList>> {
        return this.api
            .get<PaginatedResult<ArticlesPriceList>>("prices", {
                params: request.toParams(),
            })
            .then((x) => x.data);
    }
}

export const articlesPriceListsService = new ArticlesPriceListsService();
